<template>
  <ViewContainer :title="$t('common.organization_other')">
    <template v-slot:header-right>
      <CreateButton
        small
        @click="navigateTo({ name: 'organizationCreateView' })"
      />
    </template>

    <v-row class="mt-2">
      <v-col cols="12">
        <v-data-table
          class="table-widget elevation-2"
          :search="search"
          :headers="headers"
          :items="organizationItems"
          :items-per-page="10"
          :footer-props="footerOptions"
        >
          <template v-slot:top>
            <v-row class="px-2 py-4 mb-2">
              <v-col cols="6">
                <SearchInput
                  class="mr-4"
                  :value="search"
                  @change="search = $event"
                />
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.name="{ item }">
            <router-link
              class="cursor-pointer text-decoration-none"
              :to="{
                path: `/organization-settings/${item.id}`,
                query: { option: 'admin' },
              }"
            >
              {{ item.name }}
            </router-link>
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ item.createdAtText }}
          </template>
          <template v-slot:item.structure="{ item }">
            <router-link
              :to="`/organization-structure/${item.id}`"
              class="cursor-pointer text-decoration-none"
            >
              {{ $t('common.structure') }}
            </router-link>
          </template>
          <template v-slot:item.users="{ item }">
            <router-link
              :to="`/admin/organizations/${item.id}/users`"
              class="cursor-pointer text-decoration-none"
            >
              {{ $t('common.users.user_other') }}
            </router-link>
          </template>
          <template v-slot:item.revs="{ item }">
            <router-link
              class="cursor-pointer text-decoration-none"
              :to="`/admin/organizations/${item.id}/revs`"
            >
              {{ $t('common.rev_other') }}
            </router-link>
          </template>
          <template v-slot:item.challenges="{ item }">
            <router-link
              class="cursor-pointer text-decoration-none"
              :to="`/admin/organizations/${item.id}/challenges`"
            >
              {{ $t('common.challenge_other') }}
            </router-link>
          </template>
          <template v-slot:item.status="{ item }">
            <v-switch
              class="ma-0 pa-0 d-flex items-center"
              hide-details
              :input-value="item.status"
              :id="item.id"
              @click.native="updateOrganization(item)"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </ViewContainer>
</template>

<script>
import mixin from '@/mixins/mixin.vue'

import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'
import SearchInput from '@/components/Core/SearchInput.vue'
import CreateButton from '@/components/UI/CreateButton.vue'

import { utils } from 'frontend-js-shared'

export default {
  name: 'organizations',

  mixins: [mixin],

  components: {
    ViewContainer,
    CreateButton,
    SearchInput,
  },

  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [20, 50, 100],
      },
      search: '',
      headers: [
        {
          text: this.$t('common.name'),
          value: 'name',
          sortable: true,
          align: 'start',
        },
        {
          text: this.$t('filters.date.creation_date'),
          value: 'createdAt',
          sortable: true,
          align: 'start',
        },
        {
          text: this.$t('common.plan'),
          value: 'plan',
          sortable: true,
          align: 'start',
        },
        {
          text: '',
          value: 'structure',
          sortable: false,
          align: 'start',
        },
        {
          text: '',
          value: 'users',
          sortable: false,
          align: 'start',
        },
        {
          text: '',
          value: 'revs',
          sortable: false,
          align: 'start',
        },
        {
          text: '',
          value: 'challenges',
          sortable: false,
          align: 'start',
        },
        {
          text: this.$t('common.status'),
          value: 'status',
          sortable: false,
          align: 'left',
        },
      ],
      totalRecordsInData: 0,
      currentPage: 1,
      DEFAULT_SIZE: 200,
    }
  },

  created() {
    this.getOrganizations()
  },

  computed: {
    organizations: function() {
      return this.$store.state.organization.organizations
    },
    totalPages: function() {
      return Math.ceil(this.totalRecordsInData / this.DEFAULT_SIZE)
    },
    organizationItems() {
      const formattedOrgs = this.organizations.map(org => {
        return {
          ...org,
          createdAtText: utils.dates.humanDate(org.createdAt),
          id: org._id,
          status: !org.deletedAt && org.isEnabled,
        }
      })
      return formattedOrgs
    },
  },

  methods: {
    getOrganizations: function(page) {
      const options = {
        page: page,
        limit: this.DEFAULT_SIZE,
      }
      this.$store
        .dispatch('getAllOrganizations', options)
        .then(organizations => {
          this.totalRecordsInData = organizations.totalRecordsInData
        })
        .catch(err => {
          this.showError(err.message)
        })
    },
    goToPage: function(page) {
      this.currentPage = page
      this.getOrganizations(page)
    },

    updateOrganization(organization) {
      this.$store
        .dispatch('updateOrganizationStatus', {
          organizationId: organization.id,
          isEnabled: !organization.status,
        })
        .catch(err => {
          this.showError(err.message)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;

  .btn {
    margin-top: 10px;
  }
}

.title-text {
  flex: 2;
  margin-top: 0;
}
</style>
